import React, { useState, useEffect } from "react";

import { useUser } from "~/Context/userContext";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Button from "react-bootstrap/Button";
import axios, { axiosAuth } from "react-axios";

import { postUserSocialSave } from "~/api/getUser";
import { validate } from "./UserSocialEditValidationRules";
import useTrackCommentForm from "../useTrackCommentForm";

import styled from "styled-components";

import "~/css/forms.less";

export const Wrapper = styled.section`
  margin: 10px 0 80px 0;
`;

const UserSocialEditForm = ({ profile, onComplete, onFailure }) => {
  const { state: userState } = useUser();
  const [loading, setLoading] = useState(true);

  const { social = [] } = profile;
  const init = [];
  social.map((n) => {
    init[n.network] = n.profile_name;
  });

  const initialFormValues = {
    ...init,
  };

  useEffect(() => {
    setLoading(!userState.loaded);
  }, [userState.loaded]);

  const postProfileEdit = async () => {
    setLoading(true);

    // const formData = new FormData();

    const payload = {
      networks: {
        discogs: inputs.discogs,
        bandcamp: inputs.bandcamp,
        soundcloud: inputs.soundcloud,
        twitter: inputs.twitter,
        instagram: inputs.instagram,
      },
    };

    // for (var key in payload) {
    //   formData.append(key, payload[key]);
    // }

    try {
      await postUserSocialSave(axiosAuth, payload);
      setLoading(false);
      onComplete();
    } catch (err) {
      setLoading(false);
      onFailure();
    }
  };

  const { inputs, handleInputChange, handleSubmit, errors } = useTrackCommentForm(initialFormValues, postProfileEdit, validate);

  return (
    <Wrapper className="UserSocialEditFormWrapper">
      <Form className="totd-form totd-form-horizontal profile-edit-form" noValidate onSubmit={(e) => handleSubmit(e)}>
        <Row>
          <Col xs={12} className="">
            <Form.Group as={Row}>
              <Col md={10}>
                <InputGroup>
                  <InputGroup.Prepend>
                    <InputGroup.Text id="inputGroupPrepend">http://soundcloud.com/</InputGroup.Text>
                  </InputGroup.Prepend>
                  <Form.Control
                    name="soundcloud"
                    onChange={handleInputChange}
                    value={inputs.soundcloud || ""}
                    type="text"
                    autoComplete="off"
                  />
                </InputGroup>
              </Col>
            </Form.Group>

            <Form.Group as={Row}>
              <Col md={10}>
                <InputGroup>
                  <InputGroup.Prepend>
                    <InputGroup.Text id="inputGroupPrepend">http://twitter.com/</InputGroup.Text>
                  </InputGroup.Prepend>
                  <Form.Control name="twitter" onChange={handleInputChange} value={inputs.twitter || ""} type="text" autoComplete="off" />
                </InputGroup>
              </Col>
            </Form.Group>

            <Form.Group as={Row}>
              <Col md={10}>
                <InputGroup>
                  <InputGroup.Prepend>
                    <InputGroup.Text id="inputGroupPrepend">http://instagram.com/</InputGroup.Text>
                  </InputGroup.Prepend>
                  <Form.Control
                    name="instagram"
                    onChange={handleInputChange}
                    value={inputs.instagram || ""}
                    type="text"
                    autoComplete="off"
                  />
                </InputGroup>
              </Col>
            </Form.Group>

            <Form.Group as={Row}>
              <Col md={10}>
                <InputGroup>
                  <InputGroup.Prepend>
                    <InputGroup.Text id="inputGroupPrepend">http://bandcamp.com/</InputGroup.Text>
                  </InputGroup.Prepend>
                  <Form.Control name="bandcamp" onChange={handleInputChange} value={inputs.bandcamp || ""} type="text" autoComplete="off" />
                </InputGroup>
              </Col>
            </Form.Group>

            <Form.Group as={Row}>
              <Col md={10}>
                <InputGroup>
                  <InputGroup.Prepend>
                    <InputGroup.Text id="inputGroupPrepend">http://discogs.com/user/</InputGroup.Text>
                  </InputGroup.Prepend>
                  <Form.Control name="discogs" onChange={handleInputChange} value={inputs.discogs || ""} type="text" autoComplete="off" />
                </InputGroup>
              </Col>
            </Form.Group>

            <Button disabled={loading} variant="success" type="submit">
              Save Networks
            </Button>
          </Col>
        </Row>
      </Form>
    </Wrapper>
  );
};

export default UserSocialEditForm;
